module.exports = __webpack_public_path__ + "img/whatsApp.4b85eb21.png";